// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"237776e7","239":"d8558b68","383":"70fe4324","453":"ecb6b6ff","624":"de715435","956":"ad2e76fe","970":"563a0e88"}[chunkId] + ".chunk.js";
};